import { render, staticRenderFns } from "./popUpConfig.vue?vue&type=template&id=2f16019e&scoped=true"
import script from "./popUpConfig.vue?vue&type=script&lang=js"
export * from "./popUpConfig.vue?vue&type=script&lang=js"
import style0 from "./popUpConfig.vue?vue&type=style&index=0&id=2f16019e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16019e",
  null
  
)

export default component.exports